import { ApiError } from '@seolens/contracts';
import { AxiosError } from 'axios';

export enum ApiRoutes {
  Sites = '/sites',
  SitesAutocomplete = '/sites/autocomplete',
  SitesById = '/sites/:siteId',
  SitesContentById = '/sites/:siteId/content',

  SitesArchives = '/sites/:siteId/archives',
  SitesImportArchive = '/sites/:siteId/archives/import',
  SitesImportArchiveSignedUrl = '/sites/:siteId/archives/import/signed-url',
  SitesImportArchiveConfirm = '/sites/:siteId/archives/import/confirm',
  SitesExportArchive = '/sites/:siteId/archives/export',

  SitesTreeRoot = '/sites/:siteId/static-fs-manager/tree',
  SitesTreeFolderById = '/sites/:siteId/static-fs-manager/tree/:directoryId',
  SitesFSManagerFileContent = '/sites/:siteId/static-fs-manager/files/:staticFileId/content',
  SitesFSManagerFile = '/sites/:siteId/static-fs-manager/files/:staticFileId',
  SitesFSManagerFolder = '/sites/:siteId/static-fs-manager/folders/:folderId',

  SitesBreadcrumb = '/sites/:siteId/breadcrumb',

  SiteGroups = '/site-groups',
  SiteGroupsById = '/site-groups/:siteGroupId',
  SiteGroupsBreadcrumb = '/site-groups/:siteGroupId/breadcrumb',
  SiteGroupsSearchAnalytics = '/site-groups/:siteGroupId/search-analytics',
  SiteGroupsSitesAutocomplete = '/site-groups/sites/autocomplete',

  Pages = '/sites/:siteId/pages',
  PageNodes = '/sites/:siteId/structure',
  PageNodesRoot = '/sites/:siteId/structure/root',
  PageNodesById = '/sites/:siteId/structure/:nodeId',
  PageNodesAutocomplete = '/sites/:siteId/structure/autocomplete',
  PagesById = '/sites/:siteId/pages/:pageId',
  PagesByIdDossier = '/sites/:siteId/pages/:pageId/dossier',
  PagesBreadcrumb = '/sites/:siteId/pages/:pageId/breadcrumb',

  PagesCriticalCssSettings = '/sites/:siteId/criticalcss/settings',
  PagesCriticalCssStyleFiles = '/sites/:siteId/criticalcss/settings/styles-files',
  PagesCriticalCssGenerate = '/sites/:siteId/criticalcss/generate',
  PageCriticalCss = '/sites/:siteId/criticalcss/pages/:pageId',
  PagesCriticalCssGenerationSummary = '/sites/:siteId/criticalcss/summary',

  PageSearchAndReplace = '/sites/:siteId/pages/search-and-replace',
  PageSearchAndReplaceAutocomplete = '/sites/:siteId/pages/search-and-replace/autocomplete',
  PageSearchAndReplaceHistory = '/sites/:siteId/pages/search-and-replace/history',
  PageSearchAndReplaceHistoryRollback = '/sites/:siteId/pages/search-and-replace/rollback/:version',

  PagesPublication = '/sites/:siteId/pages/publication',
  PagesPublicationPublish = '/sites/:siteId/pages/publication/publish',
  PagesPublicationUnpublish = '/sites/:siteId/pages/publication/unpublish',

  PageComponents = '/sites/:siteId/templates/components',
  PageComponentsById = '/sites/:siteId/templates/components/:componentId',
  PageComponentsAutocomplete = '/sites/:siteId/templates/components/autocomplete',
  PageComponentsBreadcrumb = '/sites/:siteId/templates/components/:componentId/breadcrumb',

  PageLayouts = '/sites/:siteId/templates/layouts',
  PageLayoutsById = '/sites/:siteId/templates/layouts/:layoutId',
  PageLayoutsAutocomplete = '/sites/:siteId/templates/layouts/autocomplete',
  PageLayoutsBreadcrumb = '/sites/:siteId/templates/layouts/:layoutId/breadcrumb',

  Domains = '/domains',
  DomainsMultiConfiguration = '/domains/multi-configuration',
  DomainsAutocomplete = '/domains/autocomplete',
  DomainsById = '/domains/:domainId',
  DomainsByIdConfig = '/domains/:domainId/config',
  DomainsByIdConfigAttach = '/domains/:domainId/config/attach',
  DomainsByIdConfigDetach = '/domains/:domainId/config/detach',
  DomainsByIdDeploy = '/domains/:domainId/deployment/deploy',
  DomainsByIdShutdown = '/domains/:domainId/deployment/shutdown',
  DomainsByIdBreadcrumb = '/domains/:domainId/breadcrumb',
  DomainsByIdCheckHealth = '/domains/:domainId/check-health',

  SiteDomains = '/sites/:siteId/domains',
  SiteDomainsAutoRegluings = '/sites/:siteId/domains/auto-regluings',
  SiteDomainsAutocomplete = '/sites/:siteId/domains/autocomplete',
  SiteDomainsById = '/sites/:siteId/domains/:domainId',
  SiteDomainsByIdRegluings = '/sites/:siteId/domains/:domainId/regluings',
  SiteDomainsByIdRegluingsById = '/sites/:siteId/domains/:domainId/regluings/:regluingId',
  SiteDomainsByIdChangeMain = '/sites/:siteId/domains/:domainId/change-main',
  SiteDomainsByIdDenyAccess = '/sites/:siteId/domains/:domainId/deny-access',
  SiteDomainsByIdPurgeCache = '/sites/:siteId/domains/:domainId/purge-cache',

  ProxyServers = '/proxy-servers',
  ProxyServersAutocomplete = '/proxy-servers/autocomplete',
  ProxyServerAddresses = '/proxy-servers/:proxyServerId/addresses',
  ProxyServerAddressesAutocomplete = '/proxy-servers/:proxyServerId/addresses/autocomplete',
  ProxyServersById = '/proxy-servers/:proxyServerId',
  ProxyServersBreadcrumb = '/proxy-servers/:proxyServerId/breadcrumb',
  ProxyServersSupportedOS = '/proxy-servers/supported-linux-os/list',
  ProxyServerAddressesCheck = '/proxy-servers/:proxyServerId/check-addresses',
  ProxyServersByIdPassword = '/proxy-servers/:proxyServerId/password',

  DomainRegistrars = '/domain-registrars',
  DomainRegistrarsAutocomplete = '/domain-registrars/autocomplete',
  DomainRegistrarsById = '/domain-registrars/:domainRegistrarId',
  DomainRegistrarsBreadcrumb = '/domain-registrars/:domainRegistrarId/breadcrumb',
  DomainRegistrarsByIdAccounts = '/domain-registrars/:domainRegistrarId/accounts',
  DomainRegistrarsByIdAccountPassword = '/domain-registrars/:domainRegistrarId/accounts/:domainRegistrarAccountId/password',
  DomainRegistrarsByIdAccountsAutocomplete = '/domain-registrars/:domainRegistrarId/accounts/autocomplete',
  DomainRegistrarAccountsById = '/domain-registrars/:domainRegistrarId/accounts/:domainRegistrarAccountId',

  Hostings = '/hostings',
  HostingsAutocomplete = '/hostings/autocomplete',
  HostingsById = '/hostings/:hostingId',
  HostingsBreadcrumb = '/hostings/:hostingId/breadcrumb',
  HostingsByIdAccounts = '/hostings/:hostingId/accounts',
  HostingsByIdAccountsAutocomplete = '/hostings/:hostingId/accounts/autocomplete',
  HostingAccountsById = '/hostings/:hostingId/accounts/:hostingAccountId',
  HostingAccountsByIdPassword = '/hostings/:hostingId/accounts/:hostingAccountId/password',

  DomainsApiCloudflareAccounts = '/domains-api/cloudflare/accounts',
  DomainsApiCloudflareAccountsAutocomplete = '/domains-api/cloudflare/accounts/autocomplete',
  DomainsApiCloudflareAccountsById = '/domains-api/cloudflare/accounts/:cloudflareAccountId',
  DomainsApiCloudflareAccountsBreadcrumb = '/domains-api/cloudflare/accounts/:cloudflareAccountId/breadcrumb',

  DomainsApiSearchConsoleAccounts = '/domains-api/search-console/accounts',
  DomainsApiSearchConsoleAccountsAutocomplete = '/domains-api/search-console/accounts/autocomplete',
  DomainsApiSearchConsoleAccountsById = '/domains-api/search-console/accounts/:searchConsoleAccountId',
  DomainsApiSearchConsoleAccountsByIdCreds = '/domains-api/search-console/accounts/:searchConsoleAccountId/credentials',
  DomainsApiSearchConsoleAccountsBreadcrumb = '/domains-api/search-console/accounts/:searchConsoleAccountId/breadcrumb',
  DomainsApiSearchConsoleAccountsOAuth2Url = '/domains-api/search-console/accounts/:searchConsoleAccountId/oauth2-url',
  DomainsApiSearchConsoleAccountsOAuth2 = '/domains-api/search-console/accounts/:searchConsoleAccountId/oauth2',

  DomainsApiSearchConsoleAccountOTP = 'domains-api/search-console/accounts/:searchConsoleAccountId/otp',

  DnsRecords = '/dns-records',
  DnsRecordsAutocomplete = '/dns-records/autocomplete',
  DnsRecordsById = '/dns-records/:dnsRecordId',
  DnsRecordsBreadcrumb = '/dns-records/:dnsRecordId/breadcrumb',

  ExternalRedirects = '/sites/:siteId/external-redirects',
  ExternalRedirectsConflicts = '/sites/:siteId/external-redirects/conflicts',
  ExternalRedirectsBulkActivity = '/sites/:siteId/external-redirects/bulk/activity',
  ExternalRedirectsBulkDelete = '/sites/:siteId/external-redirects/bulk/delete',
  ExternalRedirectsById = '/sites/:siteId/external-redirects/:externalRedirectId',
  ExternalRedirectsBreadcrumb = '/sites/:siteId/external-redirects/:externalRedirectId/breadcrumb',

  Robots = '/sites/:siteId/robots/domains',
  RobotsById = '/sites/:siteId/robots/domains/:domainId',

  Sitemap = '/sites/:siteId/sitemap/domains',
  SitemapById = '/sites/:siteId/sitemap/domains/:domainId',
  SitemapByIdGenerate = '/sites/:siteId/sitemap/domains/:domainId/generate',

  SiteDomainsSearchConsole = '/sites/:siteId/search-console',

  SiteDomainsSearchConsoleSitemap = '/sites/:siteId/search-console/sitemap',
  SiteDomainsSearchConsoleSitemapById = '/sites/:siteId/search-console/sitemap/:domainId',

  SiteDomainsSearchConsoleAnalytics = '/sites/:siteId/search-console/search-analytics',
  SiteDomainsSearchConsoleAnalyticsById = '/sites/:siteId/search-console/search-analytics/:domainId',

  SiteDomainsSearchConsoleVerifyGoogle = '/sites/:siteId/search-console/:domainId/verify-google',
  SiteDomainsSearchConsoleGenerateToken = '/sites/:siteId/search-console/:domainId/generate-token',
  SiteDomainsSearchConsoleAddDomain = '/sites/:siteId/search-console/:domainId/add-domain',

  SiteDomainsSearchConsoleRedirectingAutoProcessing = '/sites/:siteId/search-console/redirecting-auto-processing-setting',
  SiteDomainsSearchConsoleAddRedirectingTask = '/sites/:siteId/search-console/add-redirecting-task',

  SiteDomainsSearchConsoleUrlInspection = '/sites/:siteId/search-console/url-inspection',
  SiteDomainsSearchConsoleUrlInspectionById = '/sites/:siteId/search-console/url-inspection/:domainId',
  SiteDomainsSearchConsoleUrlInspectionInspect = '/sites/:siteId/search-console/url-inspection/:domainId/inspect',

  SiteDomainsSearchConsolePushIndexing = '/sites/:siteId/search-console/indexing/push',

  Referrals = '/sites/:siteId/referrals',
  ReferralsById = '/sites/:siteId/referrals/:referralId',
  ReferralsBreadcrumb = '/sites/:siteId/referrals/:referralId/breadcrumb',

  ReferralLinks = '/sites/:siteId/referrals/:referralId/referral-links',
  ReferralLinksById = '/sites/:siteId/referrals/:referralId/referral-links/:referralLinkId',
  ReferralLinksBreadcrumb = '/sites/:siteId/referrals/:referralId/referral-links/:referralLinkId/breadcrumb',

  Redirects = '/sites/:siteId/redirects',
  RedirectsConflicts = '/sites/:siteId/redirects/conflicts',
  RedirectsPagesPaths = '/sites/:siteId/redirects/pages-paths',
  RedirectsBulkByPages = '/sites/:siteId/redirects/bulk/pages',
  RedirectsBulkByPaths = '/sites/:siteId/redirects/bulk/paths',
  RedirectsBulkActivity = '/sites/:siteId/redirects/bulk/activity',
  RedirectsBulkDelete = '/sites/:siteId/redirects/bulk/delete',
  RedirectsById = '/sites/:siteId/redirects/:redirectId',
  RedirectsBreadcrumb = '/sites/:siteId/redirects/:redirectId/breadcrumb',

  Login = '/auth/login',
  Logout = '/auth/logout',
  Session = '/auth/session-user',
}

export type QueryError = AxiosError<ApiError>;

export interface AppPaginationOptions {
  page: number;
}

export interface WithPagination<T> {
  items: NonNullable<T>[];
  meta: {
    totalItems: number;
    itemCount: number;
    itemsPerPage: number;
    totalPages: number;
    currentPage: number;
  };
}
